import * as contentful from 'contentful';



const client = contentful.createClient( {
    accessToken: process.env.REACT_APP_AccessToken,
    space: process.env.REACT_APP_space,
});

export default client;
